<template>
  <div class="scratch-program-header-box show-flex-box-r show-flex-center">
    <div class="show-flex-box-c">
      <dl class="workstation-box show-flex-box-r">
        <dt class="show-flex-box-r">
          <strong @click="tabToHome">
            <img src="../../assets/common/logo_white_icon.png" alt="德阳经开科创" draggable="false">
          </strong>
          <!-- <div class="folder-box show-flex-box-r show-flex-center">
            <el-dropdown trigger="click" @command="fileOperation">
              <span class="el-dropdown-link">
                <strong></strong>
                文件
                <i class="el-icon-caret-bottom el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" placement="bottom-start">
                <el-dropdown-item command="newProject" icon="el-icon-plus">新建项目</el-dropdown-item>
                <el-dropdown-item command="saveAs" icon="el-icon-circle-plus">另存为</el-dropdown-item>
                <el-dropdown-item command="saveToPC" icon="el-icon-circle-plus-outline">保存到电脑</el-dropdown-item>
                <el-dropdown-item command="loadMyWork" icon="el-icon-check">载入我的作品</el-dropdown-item>
                <el-dropdown-item command="uploadFromPC" icon="el-icon-circle-check-outline">从电脑中上传</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="inbox-in-box show-flex-box-r show-flex-center" @click="saveProgram">
            <strong></strong>
            <h2>保存</h2>
          </div> -->
        </dt>
        <dd class="ins-page-list show-flex-box-r">
          <div class="user-info-list show-flex-box-r">
            <div class="language-selection show-flex-box-r">
              <span></span>
              <h3>中文</h3>
            </div>
            <div class="user-info show-flex-box-r" v-if="logined" @click="tabToPersonalCenter">
              <span v-if="userInfo && userInfo.avatar">
                <img :src="userInfo.avatar" alt="德阳经开科创" v-if="userInfo.avatar" draggable="false">
              </span>
            </div>
          </div>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import regex from "@/filter/regex";

export default {
  name: "scratch_program_header_cpn",
  data() {
    return {
      finderStyle: "none",
      logined: false,
      userInfo: {},
      curPosition: "",
      isCourseDetail: "",
      forumType: "",
      courseType: "",
      // showMyWork: false
    };
  },
  computed: {
    listenToken: function() {
      return this.$store.state.token;
    },
    listenUserInfo: function() {
      return this.$store.state.user;
    }
  },
  created() {
    this.courseType = this.$route.name;
    this.forumType = this.$route.params.forum_type;
    this.curPosition = this.$route.params.type;
    this.routerInfo = this.$route.params.isCourseDetail;
    this.isGetUserInfo();
  },
  mounted() {
    this.reqRouterPath();
  },
  methods: {
    tabToPersonalCenter: function() {
      let toWhere = "/personal/set/ins_personal_center/project";
      this.$router.push({ path: toWhere });
    },
    tabToHome: function() {
      let toWhere = "/";
      this.$router.push({ path: toWhere });
    },
    isGetUserInfo: function() {
      let userToken = this.$store.state.token;
      let tokenStatus = regex.isTrueResult(userToken);

      if (tokenStatus) {
        this.getUserInfo();
        this.checkUserStatus();
      }
    },
    checkUserStatus: function() {
      let userStore = this.$store.state.user;
      let userStatus = regex.isTrueResult(userStore);

      if (userStatus) {
        this.logined = regex.isTrueResult(this.$store.state.loginStatus);
        this.userInfo = this.formatUserInfoByType(userStore);
      } else {
        this.userInfo = {};
        this.logined = regex.isTrueResult(this.$store.state.loginStatus);
      }
    },
    //用户信息数据类型转换
    formatUserInfoByType: function(userStore) {
      let dataType = typeof userStore;
      let userObj = userStore;

      // if (dataType == 'string') {
      //   userObj = $.parseJSON(userStore);
      // }

      return userObj;
    },
    getUserInfo: function() {
      let vSelf = this;

      this.$client
        .getUserInfo()
        .then(res => {
          if (res.code === "200" || res === 200) {
            vSelf.userInfo = res.data;
            let curUserInfo = vSelf.saveUserInfo(res.data);
            vSelf.$store.commit("GET_USER", curUserInfo);
          }
        })
        .catch(err => {});
    },
    // 保存用户信息
    saveUserInfo: function(userObj) {
      let userInfo;

      userInfo = {
        nickname: userObj.nickname,
        avatar: userObj.avatar,
        is_agents: regex.isTrueResult(userObj.is_agents),
        is_teacher: regex.isTrueResult(userObj.is_teacher),
        can_view_organ_post: regex.isTrueResult(userObj.can_view_organ_post),
        agents_teacher_max_num: userObj.agents_teacher_max_num,
        agents_teacher_num: userObj.agents_teacher_num
      };
      return userInfo;
    },
    tabToJumpSubcategory: function(pathName) {
      if (pathName == "scratch_program") {
        let toWhere = "/ins_scratch/scratch_program";
        this.$router.push({ path: toWhere });
      }
    },
    reqRouterPath: function() {
      this.routerInfo = this.$route.params.isCourseDetail;
      this.courseType = this.$route.name;
    },
    // 文件选项操作
    fileOperation: function(command) {
      if (command == "newProject") {
        alert("新建项目");
      } else if (command == "saveAs") {
        alert("另存为");
      } else if (command == "saveToPC") {
        alert("保存到电脑");
      } else if (command == "loadMyWork") {
        this.$store.commit('SET_SCRATCH_SELECTION','loadMyWork');
      } else if (command == "uploadFromPC") {
        alert("从电脑中上传");
      }
    },
    // 保存
    saveProgram: function() {
      alert("保存");
    }
  },
  watch: {
    $route: function(from) {
      this.reqRouterPath();
      this.curPosition = this.$route.params.type;
    },
    listenToken: function() {
      let tokenStatus = regex.isTrueResult(this.listenToken);

      if (tokenStatus) {
        this.getUserInfo();
      } else {
        this.logined = false;
      }
    },
    listenUserInfo: function() {
      this.checkUserStatus();
    }
  }
};
</script>

<style lang="less" scoped>
//公共字体样式  start

.scratch-program-header-font-style( @size; @weight; @height; @color) {
  display: block;
  font-size: @size;
  font-weight: @weight;
  line-height: @height;
  color: @color;
  word-break: break-all;
}

//公共字体样式  end

.scratch-program-header-box {
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  background: #388bff;
  & > div {
    width: 100%;
    height: 45px;
    & > .workstation-box {
      padding-left: 10px;
      padding-right: 10px;
      flex-grow: 1;
      height: 45px;
      justify-content: space-between;
      align-items: center;
      & > dt {
        width: 100%;
        height: 100%;
        align-items: center;
        & > strong {
          display: block;
          width: 97px;
          height: 16px;
          margin-right: 12px;
          cursor: pointer;
          & > img {
            width: 100%;
          }
        }
        & > .folder-box {
          width: 88px;
          height: 100%;
          cursor: pointer;
        }
        & > .folder-box:hover,
        .inbox-in-box:hover {
          transition: 0.3s;
          background: #3075d9;
        }
        & > .inbox-in-box {
          width: 88px;
          height: 100%;
          cursor: pointer;
          & > strong {
            width: 16px;
            height: 16px;
            background: url("../../assets/scratch_program/inbox_In_white_icon.png")
              no-repeat center center;
            background-size: 16px 16px;
            margin-right: 4px;
          }
          & > h2 {
            .scratch-program-header-font-style(16px; 400; normal; #fff);
          }
        }
      }
      & > .ins-page-list {
        align-items: center;
        & > .user-info-list {
          flex-shrink: 0;
          align-items: center;
          & > .language-selection {
            align-items: center;
            margin-right: 12px;
            cursor: pointer;
            & > span {
              width: 16px;
              height: 16px;
              background: url("../../assets/scratch_program/globe_white_icon.png")
                no-repeat center center;
              background-size: 16px 16px;
              margin-right: 4px;
            }
            & > h3 {
              .scratch-program-header-font-style(16px; 400; normal; #fff);
            }
          }
          & > .user-info {
            align-items: center;
            cursor: pointer;
            & > span {
              overflow: hidden;
              display: flex;
              width: 28px;
              height: 28px;
              border-radius: 100%;
              overflow: hidden;
              & > img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                flex-grow: 1;
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style scoped>
.el-dropdown {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.el-dropdown-link {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  color: #fff;
  line-height: 45px;
  text-align: center;
  font-size: 16px;
}
.folder-box /deep/ .el-dropdown-link strong {
  display: block;
  width: 16px;
  height: 16px;
  background: url("../../assets/scratch_program/folder_white_icon.png")
    no-repeat center center;
  background-size: 16px 16px;
  margin-right: 4px;
}
.el-icon-arrow-down {
  font-size: 16px;
}
.demonstration {
  display: block;
  color: #8492a6;
  font-size: 16px;
  margin-bottom: 20px;
}
.el-popper[x-placement^="bottom"] {
  margin-top: 0;
}
</style>




// WEBPACK FOOTER //
// src/components/common/scratch_program_header_cpn.vue